import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'

const SvgCloudRaining04 = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M16 18.5V21m-8-2.5V21m4-1.5V22m-5-7a5 5 0 1 1 .1-9.999 5.502 5.502 0 0 1 10.195 1.004A4.5 4.5 0 1 1 17.5 15H6.999Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgCloudRaining04)
export default ForwardRef
